import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Layout from "../../../components/layout";
import ProcessOrderForm from "../../../components/processOrders/ProcessOrderForm";
import { useAppSelector } from "../../../app/hooks";
import { getLoggingUser } from "../../../features/loggingUser/loggingUserSlice";
import { getSelectedBranch } from "../../../features/settings/settingsSlice";
import { useCanAccess } from "../../../hooks/useCanAccess";
import { useProcessDefinitionFromQuery } from "../../../hooks/useProcessDefinitionFromQuery";
import { localizedProcessName } from "../../../lib/utils";
import { t } from "../../../locales";
import { route } from "../../../static/route";

const ProcessOrderCreatePage = () => {
  const navigate = useNavigate();
  const canAccess = useCanAccess();
  const loggingUser = useAppSelector(getLoggingUser);
  const selectedBranch = useAppSelector(getSelectedBranch);
  const { processDefinition, loading } = useProcessDefinitionFromQuery(t.processOrders.processNotSupported);

  useEffect(() => {
    if (loggingUser?.permissions && selectedBranch && !canAccess("process-orders.create")) {
      navigate(route.dashboard);
    }
  }, [loggingUser, selectedBranch]);

  return (
    <Layout>
      <div className="px-2 py-4 md:px-6 md:py-6">
        <nav className="text-sm font-semibold text-gray-500 mb-4">
          <Link to={route.dashboard} className="text-brand-dark hover:underline">
            {t.processOrders.breadcrumbHome}
          </Link>
          <span className="mx-2">&rsaquo;</span>
          {processDefinition && (
            <>
              <Link to={`${route.processOrders}?process=${processDefinition.slug}`} className="text-brand-dark hover:underline">
                {t.processOrders.breadcrumbList}
              </Link>
              <span className="mx-2">&rsaquo;</span>
            </>
          )}
          <span className="text-gray-500">{t.processOrders.addTitle}</span>
        </nav>
        <h1 className="text-2xl font-bold text-brand-dark mb-6">
          {processDefinition ? `${localizedProcessName(processDefinition)} — ${t.processOrders.addTitle}` : t.processOrders.addTitle}
        </h1>
        {loading || !processDefinition ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-[#113F67]" />
          </div>
        ) : (
          <ProcessOrderForm processDefinition={processDefinition} />
        )}
      </div>
    </Layout>
  );
};

export default ProcessOrderCreatePage;
